export default __webpack_public_path__ + "static/media/kitchen4-afterC-768w.6710ef58.webp";